import { RESET_STATE } from 'store/global/actions';

import { ROLE_USERS_ACTION_TYPE } from '../actions';

const initialState = {
  savedRoleUsersIds: [],
  currentRoleUsersIds: [],
};

const roleUsersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ROLE_USERS_ACTION_TYPE.GET_ROLE_USERS:
      return {
        savedRoleUsersIds: payload,
        currentRoleUsersIds: payload,
      };

    case ROLE_USERS_ACTION_TYPE.TOGGLE_ROLE_FOR_USERS:
      return {
        ...state,
        currentRoleUsersIds: state.currentRoleUsersIds.includes(payload)
          ? state.currentRoleUsersIds.filter(id => id !== payload)
          : [...state.currentRoleUsersIds, payload],
      };

    case ROLE_USERS_ACTION_TYPE.SAVE_ROLE_USERS:
    case ROLE_USERS_ACTION_TYPE.DELETE_ROLE_USERS:
      return {
        ...state,
        savedRoleUsersIds: state.currentRoleUsersIds,
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default roleUsersReducer;
